import { call, put, select } from 'redux-saga/effects'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { showSnackbar, SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'
import { updateFidelityMaximizer } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { selectExtraRoutesAuthData } from '@/containers/Login/AuthSelectors'
import * as Sentry from '@sentry/react'

export const fidelityMaximizerModuleActions = {
  FIDELITY_MAXIMIZER_LOAD_STATUS: 'FIDELITY_MAXIMIZER_LOAD_STATUS',
  FIDELITY_MAXIMIZER_TRIGGER_ACTION: 'FIDELITY_MAXIMIZER_TRIGGER_ACTION',
}

const mapStatusResponse = data => ({
  loading: false,
  loaded: true,
  enabled: data?.enabled === true,
  checklist: data?.checklist ?? {
    nlbp_classic: false,
    nlbp_personalized: false,
    myselectra: false,
    app_downloaded: false,
  },
  isPdlEligible: data?.is_pdl_eligible === true,
  scenarioKey: data?.scenario_key ?? null,
  actionKey: data?.action_key ?? null,
  actionAvailable: data?.action_available === true,
  error: null,
})

export function* loadFidelityMaximizerStatus({ contactId }) {
  if (!contactId) {
    return
  }

  yield put(updateFidelityMaximizer({ loading: true, error: null }))

  try {
    const { fidelityMaximizerStatusUrl } = yield select(selectExtraRoutesAuthData)
    const response = yield call(callApi, {
      endpoint: fidelityMaximizerStatusUrl,
      method: 'GET',
      asteriskReplacement: contactId,
      showErrorSnackbar: false,
    })

    yield put(updateFidelityMaximizer(mapStatusResponse(response?.data)))
  } catch (error) {
    yield put(updateFidelityMaximizer({ loading: false, loaded: true, error: error?.message || null }))

    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('loadFidelityMaximizerStatusError'), { extra: { error } })
    }
  }
}

export function* triggerFidelityMaximizerAction({ contactId, action, enqueue }) {
  yield put(updateFidelityMaximizer({ actionLoading: true }))

  try {
    const { fidelityMaximizerActionUrl } = yield select(selectExtraRoutesAuthData)
    const response = yield call(callApi, {
      endpoint: fidelityMaximizerActionUrl,
      method: 'POST',
      asteriskReplacement: contactId,
      payload: { action },
      showErrorSnackbar: false,
    })

    yield put(updateFidelityMaximizer({ actionLoading: false }))
    yield call(showSnackbar, enqueue, {
      type: SNACKBAR_TYPES.SUCCESS,
      message: response?.data?.message || 'Action envoyée avec succès.',
    })

    yield call(loadFidelityMaximizerStatus, { contactId })
  } catch (error) {
    yield put(updateFidelityMaximizer({ actionLoading: false }))

    const backendMessage = error?.responseData?.error?.message || error?.message || "Erreur lors de l'envoi."
    yield call(showSnackbar, enqueue, {
      type: SNACKBAR_TYPES.ERROR,
      message: backendMessage,
    })

    const status = error?.status || 'unknown'
    if (import.meta.env.PROD && status !== 422) {
      Sentry.captureException(new Error('triggerFidelityMaximizerActionError'), { extra: { error } })
    }
  }
}
